import { Model } from "@vuex-orm/core";
import { max, parseISO } from "date-fns";
import { orderBy } from "lodash";
import { isTodayOrFutureDate, isTodayOrPastDate } from "@/utils/eproDate";
import { buildNameFromFirstAndLastName } from "@/utils/profile";

export default class EproPatient extends Model {
  static entity = "eproPatients";
  static primaryKey = "patientUsername";

  static fields() {
    return {
      patientUsername: this.attr(null),
      fullName: this.attr(""),
      programActive: this.attr(false),
      lastAnsweredDate: this.attr(null),
      email: this.attr(null),
      patientSiteId: this.attr(null),
      isAccountDeactivated: this.attr(false),
      isArchived: this.attr(false),
    };
  }

  static async loadPatientsWithProgram() {
    const response = await this.api().get("patient", {
      save: false,
      dataKey: "result",
    });

    const rawPatients =
      response.response.data?.result ?? response.response.data;
    if (!rawPatients) return;

    const processed = rawPatients
      .map((row) => {
        let isActiveProgram = false;
        for (const key in row.programs) {
          const { paused, stopped, startDate, endDate } = row.programs[key];
          if (
            !paused &&
            !stopped &&
            isTodayOrPastDate(parseISO(startDate)) &&
            (endDate ? isTodayOrFutureDate(parseISO(endDate)) : true)
          ) {
            isActiveProgram = true;
            break;
          }
        }

        let lastAnsweredDate = null;
        if (isActiveProgram && row.latestAnsweredProgramData) {
          const dates = Object.values(row.latestAnsweredProgramData).filter(
            (val) => val
          );
          if (dates.length > 0) {
            lastAnsweredDate = max(dates.map((d) => parseISO(d))).toISOString();
          }
        }

        return {
          patientUsername: row.patientUsername,
          fullName: buildNameFromFirstAndLastName(
            row.userProfileDetail.firstName,
            row.userProfileDetail.lastName
          ),
          programActive: isActiveProgram,
          lastAnsweredDate,
          email: row.userProfileDetail.email,
          patientSiteId: row.userProfileDetail.patientSiteId,
          isAccountDeactivated: row.userProfileDetail.isAccountDeactivated,
          isArchived: row.userProfileDetail.isArchived,
        };
      })
      .filter((row) => !row.isArchived);

    const sorted = orderBy(
      processed,
      [
        (item) => (item.lastAnsweredDate ? 1 : 0),
        (item) =>
          item.lastAnsweredDate ? new Date(item.lastAnsweredDate) : null,
      ],
      ["desc", "desc"]
    );

    await this.insertOrUpdate({ data: sorted });
  }
}
